<template>
  <div class="home">
    <section class="search">
      <div class="container-fluid">
        <div class="section-title text-center mb-4 mb-lg-5">
          <h2 class="text-white mb-2">Find your perfect stay with us</h2>
          <p class="text-white mb-0">
            Where comfort meets affordability. Unit starts at ₱5,000
          </p>
        </div>
        <form id="search_units_form" @submit.prevent="searchUnits()" class="w-100">
          <div class="d-flex flex-column flex-lg-row gap-2 w-100">
            <div class="row gx-0 gx-lg-2 gy-2 gy-lg-0 w-100">
              <div class="col-lg-3">
                <div class="dropdown">
                  <button @mouseover="getPlaces()" class="btn btn-default dropdown-toggle text-start w-100" type="button"
                    data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                    <div class="d-flex justify-content-between gap-4">
                      <div v-if="strCity == ''">Select city</div>
                      <div v-else>{{ strCity }}</div>
                      <a href="#" v-if="strCity != ''" @click.prevent="
                        strCity = '';
                      search.cityid = 0;
                      getUnits();
                                                                        ">
                        <i class="fas fa-times"></i>
                      </a>
                    </div>
                  </button>
                  <div class="dropdown-menu dropdown-menu-city p-3">
                    <div class="text-muted d-flex justify-content-between gap-4 mb-3">
                      City
                      <span v-if="strCity != ''">
                        <a href="#" role="button" @click.prevent="
                          strCity = '';
                        search.cityid = 0;
                                                                              ">
                          Clear</a>
                      </span>
                    </div>
                    <div class="overflow-hidden rounded">
                      <div v-if="is_places_loaded" class="row g-2">
                        <div v-for="place in arrPlaces" class="col-4">
                          <a href="#" class="card rounded-0" @click.prevent="
                            strCity = place.CityName;
                          search.cityid = place.CityID;
                                                                                    ">
                            <img src="@/assets/img/cities/quezon-city.webp" class="img-fluid" alt="..." />
                            <div class="card-title w-100 text-truncate">
                              {{ place.CityName }}
                            </div>
                          </a>
                        </div>
                      </div>
                      <div v-else class="row g-2">
                        <div class="col-4">
                          <div class="square shimmer"></div>
                        </div>
                        <div class="col-4">
                          <div class="square shimmer"></div>
                        </div>
                        <div class="col-4">
                          <div class="square shimmer"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <input class="form-control date-input" id="search_date_from" v-model="search.datefrom" type="date" />
              </div>
              <div class="col-lg-3">
                <input class="form-control date-input" id="search_date_to" v-model="search.dateto" type="date" />
              </div>
              <div class="col-lg-3">
                <div class="dropdown">
                  <button class="btn btn-default dropdown-toggle-0 text-start w-100" type="button"
                    data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                    <div class="d-flex justify-content-between gap-4">
                      <div v-if="intTotalCount == 0">Add guests</div>
                      <div v-else>
                        <span v-if="intTotalCount <= 1">{{ intTotalCount }} guest</span>
                        <span v-else>{{ intTotalCount }} guests</span>
                      </div>
                      <a href="#" v-if="intTotalCount != ''" @click.prevent="
                        (search.intAdults = 1),
                        (search.intChildren = 0),
                        (intTotalCount = 0)
                      ">
                        <i class="fas fa-times"></i>
                      </a>
                    </div>
                  </button>
                  <div class="dropdown-menu dropdown-menu-lg-end dropdown-menu-guest p-3">
                    <div class="text-muted d-flex justify-content-between gap-4 mb-3">
                      Guest
                      <span v-if="search.intAdults != 1 || search.intChildren != 0">
                        <a href="#" role="button" @click.prevent="
                          (search.intAdults = 1),
                          (search.intChildren = 0),
                          (intTotalCount = 0)
                        ">
                          Clear</a>
                      </span>
                    </div>
                    <div class="d-flex flex-column gap-3">
                      <div class="d-flex justify-content-between align-items-end gap-3 gap-lg-5">
                        <div class="d-flex flex-column">
                          <span class="fw-bold">Adults</span>
                          <span class="small text-muted" style="white-space: nowrap">Ages 13 or above</span>
                        </div>
                        <div class="d-inline-block">
                          <div class="d-flex flex-nowrap">
                            <button class="btn btn-default btn-icon btn-icon-xs" type="button"
                              :disabled="search.intAdults <= 1" @click="
                                subtractAdultCount(1);
                              addTotalCount();
                                                                                              ">
                              <i class="fas fa-minus fa-sm"></i>
                            </button>
                            <input type="text" v-model="search.intAdults"
                              class="form-control form-control-xs bg-white text-center" style="
                                    width: 35px;
                                    background-color: transparent !important;
                                    border-color: transparent !important;
                                    box-shadow: none !important;
                                  " readonly />
                            <button class="btn btn-default btn-icon btn-icon-xs" type="button" @click="
                              addAdultCount(1);
                            addTotalCount();
                                                                                          ">
                              <i class="fas fa-plus fa-sm"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-content-between align-items-end gap-3 gap-lg-5">
                        <div class="d-flex flex-column">
                          <span class="fw-bold">Children</span>
                          <span class="small text-muted" style="white-space: nowrap">Ages 2-12</span>
                        </div>
                        <div class="d-inline-block">
                          <div class="d-flex flex-nowrap">
                            <button class="btn btn-default btn-icon btn-icon-xs" type="button"
                              :disabled="search.intChildren <= 0" @click="
                                subtractChildCount(1);
                              addTotalCount();
                                                                                              ">
                              <i class="fas fa-minus fa-sm"></i>
                            </button>
                            <input type="text" value="0" class="form-control form-control-xs text-center" style="
                                    width: 35px;
                                    background-color: transparent !important;
                                    border-color: transparent !important;
                                    box-shadow: none !important;
                                  " readonly v-model="search.intChildren" />
                            <button class="btn btn-default btn-icon btn-icon-xs" type="button" @click="
                              addChildCount(1);
                            addTotalCount();
                                                                                          ">
                              <i class="fas fa-plus fa-sm"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-block">
              <button class="btn btn-search" style="background-color: #1eacff; color: white" type="submit">
                Search
              </button>
            </div>
          </div>
        </form>
      </div>
    </section>

    <section id="unitList" class="unit-list bg-light">
      <div class="container-fluid">
        <div class="pb-4">
          <div class="d-flex justify-content-between gap-2 gap-lg-3 adjust-m">
            <div class="d-inline-block">
              <select :disabled="this.units.length == 0 ? true : false" class="form-select" v-model="filter.strSort"
                @change="sortUnits()">
                <option value="1" :disabled="filter.strSort == 1">
                  Alphabetical A to Z
                </option>
                <option value="2" :disabled="filter.strSort == 2">
                  Alphabetical Z to A
                </option>
                <option value="3" :disabled="filter.strSort == 3">
                  Price Low to High
                </option>
                <option value="4" :disabled="filter.strSort == 4">
                  Price High to Low
                </option>
              </select>
            </div>
            <div class="d-inline-block">
              <button type="button" class="btn btn-default position-relative"
                :class="filterUsed.length > 1 ? 'outlined' : ''" data-bs-toggle="modal" data-bs-target="#filterModal">
                <i class="fas fa-list me-3"></i>Filters
                <span v-if="filterUsed.length" class="rounded position-absolute top-0 start-0 w-100 h-100"
                  style="border: 2px solid #dc3545"></span>
              </button>
            </div>
          </div>
        </div>

        <div v-if="units.length" class="units-grid">

          <div v-for="unit in units" class="unit-box">

            <div :id="'carouselExampleControlsNoTouching' + unit.UnitCode" class="carousel slide" data-bs-touch="false"
              data-bs-interval="false">

              <!-- <ol class="carousel-indicators">
                <li v-for="(imgs, index) in !unit.UnitImages ? unit.UnitImages : unit.UnitImages.split(',')" :key="index"
                  :data-bs-target="'#carouselExampleControlsNoTouching' + unit.UnitCode" :data-bs-slide-to="index"
                  aria-current="true" class="active"></li>
              </ol> -->
              <div class="carousel-indicators home-carousel-indicators" style="overflow: hidden;">
                <div v-for="(imgs, index) in !unit.UnitImages ? unit.UnitImages : unit.UnitImages.split(',')">
                  <button v-if="index == 0" type="button" :data-bs-target="'#carouselExampleControlsNoTouching' + unit.UnitCode" :data-bs-slide-to="index" aria-current="true" :aria-label="'Slide ' + index + 1" class="active"></button>
                  <button v-else type="button" :data-bs-target="'#carouselExampleControlsNoTouching' + unit.UnitCode" :data-bs-slide-to="index" aria-label="Slide 2"></button>
                </div>
              </div>

              <div class="carousel-inner home-carousel-inner" >
                <div v-for="(imgs, index) in !unit.UnitImages ? unit.UnitImages : unit.UnitImages.split(',')" :key="index">
                  <a v-if="index == 0" href="#" class="carousel-item home-carousel-item active" style="text-decoration: none; box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 3px 0px;"
                    @click.prevent="redirectToRoomDetails(unit.UnitCode, search.datefrom, search.dateto, search.adults, search.children)">
                    <img :src="setUnitImage(imgs)" class="unit-carousel-img" alt="..."/>
                  </a>
                  <a v-else class="carousel-item home-carousel-item" href="#"
                    @click.prevent="redirectToRoomDetails(unit.UnitCode, search.datefrom, search.dateto, search.adults, search.children)">
                    <img :src="setUnitImage(imgs)" class="unit-carousel-img" alt="..."/>
                  </a>
                </div>
              </div>

              <!-- carousel buttons starts -->
              <button class="carousel-control-prev" type="button" :data-bs-target="
                '#carouselExampleControlsNoTouching' + unit.UnitCode
              " data-bs-slide="prev">
                <!-- <span class="carousel-control-prev-icon" aria-hidden="true"></span> -->
                <span><i class="bi bi-chevron-left"></i></span>
                <span class="visually-hidden">Previous</span>
              </button>
              <button class="carousel-control-next" type="button" :data-bs-target="
                '#carouselExampleControlsNoTouching' + unit.UnitCode
              " data-bs-slide="next">
                <!-- <span class="carousel-control-next-icon" aria-hidden="true"></span> -->
                <span><i class="bi bi-chevron-right"></i></span>
                <span class="visually-hidden">Next</span>
              </button>
              <!-- carousel buttons end -->
            </div>

            <a href="#"
              @click.prevent="redirectToRoomDetails(unit.UnitCode, search.datefrom, search.dateto, search.adults, search.children)" style="text-decoration: none;">
              <div class="d-flex justify-content-between align-center mt-1">
                <h5 class="card-title mt-2 fw-bold">
                  {{ unit.UnitNumber }}
                </h5>
                <!-- <span class="fw-normal" style="white-space: nowrap">
                  <i class="fas fa-star text-secondary me-2"></i>4.9
                </span> -->

              </div>
              <span>
                {{ unit.ProjectName }}
              </span>
              <div class="small text-muted-mb-2">
                {{ unit.ProjectCategory + ", " + unit.PlaceType }}
              </div>
              <div class="text-dark fw-bold">
                ₱{{ formatCurrency(unit.RateAmount) }}
              </div>
            </a>

          </div>
        </div>

        <div v-else class="card text-center" style="border: 2px dashed var(--nsjbi-border-color)">
          <div class="card-body d-flex flex-column justify-content-center h-100 p-4 p-lg-5">
            <h6 class="fw-bold mb-2">No results found</h6>
            <p class="text-muted mb-0">
              Sorry, we could not found any matches.
            </p>
          </div>
        </div>

        <form id="filter_units_form" @submit.prevent="filterUnits()">
          <div class="modal fade" id="filterModal" tabindex="-1" aria-labelledby="filterModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header p-4">
                  <h5 class="fw-bold mb-0" id="filterModalLabel">Filter</h5>
                  <a href="#" class="btn btn-default btn-icon btn-icon-sm rounded-circle" role="button"
                    data-bs-dismiss="modal" aria-label="Close">
                    <i class="fas fa-times"></i>
                  </a>
                </div>
                <div class="modal-body p-0">
                  <div class="card-body border-bottom p-4">
                    <h6 class="d-flex justify-content-between align-items-end text-dark fw-bold mb-3">
                      Project category
                      <a href="#" v-if="filter.strProjectCategory != 0" @click.prevent="filter.strProjectCategory = 0"
                        class="fw-normal" style="line-height: 0.8; font-size: 14px">Clear</a>
                    </h6>
                    <div class="d-flex flex-column gap-2">
                      <div class="d-flex" style="gap: 0.75rem">
                        <div class="d-flex">
                          <input type="radio" class="form-check-input" id="1" value="1"
                            v-model="filter.strProjectCategory" />
                        </div>
                        <label for="1" class="form-check-label">Houses</label>
                      </div>
                      <div class="d-flex" style="gap: 0.75rem">
                        <div class="d-flex">
                          <input type="radio" class="form-check-input" id="2" value="2"
                            v-model="filter.strProjectCategory" />
                        </div>
                        <label for="2" class="form-check-label">Apartment</label>
                      </div>
                      <div class="d-flex" style="gap: 0.75rem">
                        <div class="d-flex">
                          <input type="radio" class="form-check-input" id="3" value="3"
                            v-model="filter.strProjectCategory" />
                        </div>
                        <label for="3" class="form-check-label">Guest Houses</label>
                      </div>
                      <div class="d-flex" style="gap: 0.75rem">
                        <div class="d-flex">
                          <input type="radio" class="form-check-input" id="4" value="4"
                            v-model="filter.strProjectCategory" />
                        </div>
                        <label for="4" class="form-check-label">Hotel</label>
                      </div>
                    </div>
                  </div>
                  <div class="card-body border-bottom p-4">
                    <h6 class="d-flex justify-content-between align-items-end text-dark fw-bold mb-3">
                      Price range
                      <a href="#" v-if="
                        filter.dcmMinPrice != 0 || filter.dcmMaxPrice != 0
                      " @click.prevent="
  filter.dcmMinPrice = 0;
filter.dcmMaxPrice = 0;
                            " class="fw-normal" style="line-height: 0.8; font-size: 14px">Clear</a>
                    </h6>
                    <div class="d-flex gap-2">
                      <input type="number" class="form-control" placeholder="Min" min="0" v-model="filter.dcmMinPrice" />
                      <input type="number" class="form-control" placeholder="Max" min="0" v-model="filter.dcmMaxPrice" />
                    </div>
                  </div>
                  <div class="card-body p-4">
                    <h6 class="d-flex justify-content-between align-items-end text-dark fw-bold mb-3">
                      Type of place
                      <a href="#" v-if="filter.strPlaceType != 0" @click.prevent="filter.strPlaceType = 0"
                        style="line-height: 0.8; font-size: 14px" class="fw-normal">Clear</a>
                    </h6>
                    <div class="d-flex flex-column gap-2">
                      <div class="d-flex" style="gap: 0.75rem">
                        <div class="d-flex">
                          <input type="radio" class="form-check-input" id="entire_place" value="1"
                            v-model="filter.strPlaceType" />
                        </div>
                        <label for="entire_place" class="form-check-label">Entire place</label>
                      </div>
                      <div class="d-flex" style="gap: 0.75rem">
                        <div class="d-flex">
                          <input type="radio" class="form-check-input" id="shared_room" value="2"
                            v-model="filter.strPlaceType" />
                        </div>
                        <label for="shared_room" class="form-check-label">Shared room</label>
                      </div>
                      <div class="d-flex" style="gap: 0.75rem">
                        <div class="d-flex">
                          <input type="radio" class="form-check-input" id="private_room" value="3"
                            v-model="filter.strPlaceType" />
                        </div>
                        <label for="private_room" class="form-check-label">Private room</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer d-flex gap-2 p-4">
                  <button :disabled="is_apply_filter_button_disabled" type="button" class="btn btn-transparent btn-sm"
                    data-bs-dismiss="modal" @click="clearFilters()">
                    Clear all
                  </button>
                  <button :disabled="is_apply_filter_button_disabled" type="submit" class="btn btn-primary btn-sm">
                    Apply filters
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import "@/assets/css/home.css";
import SearchBlock from "@/components/SearchBlock.vue";
import UnitSkeletonLoader from "@/components/UnitSkeletonLoader.vue";
import { format, parseISO } from "date-fns";

export default {
  name: "Home",
  components: {
    SearchBlock,
    UnitSkeletonLoader,
  },
  data: () => ({
    url: process.env.VUE_APP_API_URL,
    is_apply_filter_button_disabled: true,
    is_places_loaded: false,
    units: [],
    search: {
      cityid: 0,
      datefrom: "",
      dateto: "",
      adults: 1,
      children: 0,
    },
    strCity: "",
    intTotalCount: 0,
    arrPlaces: [],
    filter: {
      strRecordID: 0,
      strProjectCategory: 0,
      dcmMinPrice: 0,
      dcmMaxPrice: 0,
      strPlaceType: 0,
      strSort: 1,
    },
    filterUsed: [],
    email_Address: "",
    email_confirmation_date: "",
  }),
  mounted() {
    var startDate = new Date();

    this.strCity = this.$route.query.city != null ? this.$route.query.city : "";
    this.search.datefrom =
      this.$route.query.check_in != null
        ? this.$route.query.check_in
        : startDate.toISOString().split("T")[0];
    this.search.dateto =
      this.$route.query.check_out != null ? this.$route.query.check_out : "";
    this.search.adults =
      this.$route.query.adult != null ? parseInt(this.$route.query.adult) : 0;
    this.search.children =
      this.$route.query.child != null ? parseInt(this.$route.query.child) : 0;

    this.filter.strProjectCategory =
      this.$route.query.project_category != null
        ? this.$route.query.project_category
        : 0;

    this.filter.dcmMinPrice =
      this.$route.query.min_price != null
        ? parseInt(this.$route.query.min_price)
        : 0;
    this.filter.dcmMaxPrice =
      this.$route.query.max_price != null
        ? parseInt(this.$route.query.max_price)
        : 0;

    this.filter.strPlaceType =
      this.$route.query.place_type != null
        ? parseInt(this.$route.query.place_type)
        : 0;
    this.filter.strSort =
      this.$route.query.sort_by != null
        ? parseInt(this.$route.query.sort_by)
        : 1;

    this.email_confirmation_date =
      this.$route.query.exp != null ? this.$route.query.exp : "";
    this.email_address =
      this.$route.query.email != null ? this.$route.query.email : "";

    this.getUnits();
    this.addTotalCount();
    this.countAppliedFilters();
  },
  updated() {
    $(".owl-carousel").owlCarousel({
      loop: false,
      margin: 8,
      nav: true,
      dots: true,
      items: 1,
    });
  },
  watch: {
    "filter.strProjectCategory"() {
      this.isApplyFilterButtonDisabled();
    },
    "filter.dcmMinPrice"() {
      this.isApplyFilterButtonDisabled();
    },
    "filter.dcmMaxPrice"() {
      this.isApplyFilterButtonDisabled();
    },
    "filter.strPlaceType"() {
      this.isApplyFilterButtonDisabled();
    },
    "filter.strSort"() {
      this.isApplyFilterButtonDisabled();
      this.changeQueryString();
    },
  },
  methods: {
    async getUnits() {
      const res = await axios.get(
        "https://testbnb-api.nsjbi.com.ph/api/units",
        {
          params: this.filter,
        }
      );
      this.units = JSON.parse(res.data);
      var myElement = document.getElementById("unitList");
      var topPos = myElement.offsetTop;
    },
    async getPlaces() {
      const res = await axios.get(
        "https://testbnb-api.nsjbi.com.ph/api/viewcity",
        {
          params: {
            intCityID: 1,
          },
        }
      );
      this.arrPlaces = JSON.parse(res.data);
      this.is_places_loaded = true;
    },
    async searchUnits() {
      if (
        this.strCity != this.$route.query.city ||
        this.search.datefrom != this.$route.query.check_in ||
        this.search.dateto != this.$route.query.check_out ||
        this.search.adults != this.$route.query.adult ||
        this.search.children != this.$route.query.child
      ) {
        var form = document.getElementById("search_units_form");
        var elements = form.elements;

        for (var i = 0, len = elements.length; i < len; ++i) {
          elements[i].disabled = true;
        }

        try {
          if (this.search.cityid != 0) {
            const res = await axios.get(
              "https://testbnb-api.nsjbi.com.ph/api/search",
              {
                params: this.search,
              }
            );
            if (res.data != "No records to display") {
              this.units = JSON.parse(res.data);
            } else {
              this.units = [];
            }
          } else if (
            this.search.cityid == 0 &&
            this.search.datefrom == "" &&
            this.search.dateto == "" &&
            this.search.adults == 0 &&
            this.search.children == 0
          ) {
            this.getUnits();
          }
        } finally {
          for (var i = 0, len = elements.length; i < len; ++i) {
            elements[i].disabled = false;
          }
          this.changeQueryString();
        }
      }
    },
    async filterUnits() {
      var form = document.getElementById("filter_units_form");
      var elements = form.elements;

      for (var i = 0, len = elements.length; i < len; ++i) {
        elements[i].disabled = true;
      }

      try {
        const res = await axios.get(
          "https://testbnb-api.nsjbi.com.ph/api/units",
          {
            params: this.filter,
          }
        );
        if (res.data != "No unit records to display.") {
          this.units = JSON.parse(res.data);
        } else {
          this.units = [];
        }
        $("#filterModal").modal("hide");
        this.countAppliedFilters();
      } finally {
        for (var i = 0, len = elements.length; i < len; ++i) {
          elements[i].disabled = false;
        }
        this.changeQueryString();
      }
    },
    sortUnits() {
      if (this.filter.strSort == 1) {
        let sorted_data = this.units.sort((a, b) =>
          a.ProjectSubName > b.ProjectSubName
            ? 1
            : a.ProjectSubName < b.ProjectSubName
              ? -1
              : 0
        );
        this.units = sorted_data;
      } else if (this.filter.strSort == 2) {
        let sorted_data = this.units.sort((a, b) =>
          b.ProjectSubName > a.ProjectSubName
            ? 1
            : b.ProjectSubName < a.ProjectSubName
              ? -1
              : 0
        );
        this.units = sorted_data;
      } else if (this.filter.strSort == 3) {
        let sorted_data = this.units.sort((a, b) =>
          a.RateAmount > b.RateAmount ? 1 : a.RateAmount < b.RateAmount ? -1 : 0
        );
        this.units = sorted_data;
      } else if (this.filter.strSort == 4) {
        let sorted_data = this.units.sort((a, b) =>
          b.RateAmount > a.RateAmount ? 1 : b.RateAmount < a.RateAmount ? -1 : 0
        );
        this.units = sorted_data;
      }
    },
    isApplyFilterButtonDisabled() {
      if (
        this.filter.dcmMinPrice == 0 &&
        this.filter.dcmMaxPrice == 0 &&
        this.filter.strProjectCategory == 0 &&
        this.filter.strPlaceType == 0
      ) {
        this.is_apply_filter_button_disabled = true;
      } else {
        this.is_apply_filter_button_disabled = false;
      }
    },
    redirectToRoomDetails(unitCode, dateFrom, dateTo, adultCount, childCount) {
      this.$router.push({
        name: "Unit",
        params: { str_unit_code: unitCode },
        query: {
          check_in: dateFrom || undefined,
          check_out: dateTo || undefined,
          adult: adultCount || undefined,
          child: childCount || undefined,
        },
      });
    },
    setUnitImage(path) {
      if (path !== null) {
        let replaced_path = path.replace(/\\/g, "/");
        let new_path = replaced_path.substring(1);

        return "https://testbnb-api.nsjbi.com.ph/" + new_path;
      }
    },

    formatCurrency(val) {
      if (val !== null) {
        return val.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
    },
    addTotalCount() {
      this.intTotalCount = this.search.adults + this.search.children;
    },
    addAdultCount(inc) {
      this.search.adults += inc;
    },
    subtractAdultCount(dec) {
      if (this.search.adults > 1) {
        this.search.adults -= dec;
      }
    },
    addChildCount(inc) {
      this.search.children += inc;
    },
    subtractChildCount(dec) {
      if (this.search.children > 0) {
        this.search.children -= dec;
      }
    },
    clearFilters() {
      this.filter.dcmMinPrice = 0;
      this.filter.dcmMaxPrice = 0;
      this.filter.strProjectCategory = 0;
      this.filter.strPlaceType = 0;
      this.filter.strSort = 1;
      this.filterUsed = [];

      this.getUnits();
      this.changeQueryString();
    },
    countAppliedFilters() {
      if (this.filter.dcmMinPrice != 0) {
        if (!this.filterUsed.includes("dcmMinPrice")) {
          this.filterUsed.push("dcmMinPrice");
        }
      } else {
        const data = this.filterUsed.filter(
          (item, pos) => item != "dcmMinPrice"
        );
        this.filterUsed = data;
      }

      if (this.filter.dcmMaxPrice != 0) {
        if (!this.filterUsed.includes("dcmMaxPrice")) {
          this.filterUsed.push("dcmMaxPrice");
        }
      } else {
        const data = this.filterUsed.filter(
          (item, pos) => item != "dcmMaxPrice"
        );
        this.filterUsed = data;
      }

      if (this.filter.strProjectCategory != 0) {
        if (!this.filterUsed.includes("strProjectCategory")) {
          this.filterUsed.push("strProjectCategory");
        }
      } else {
        const data = this.filterUsed.filter(
          (item, pos) => item != "strProjectCategory"
        );
        this.filterUsed = data;
      }

      if (this.filter.strPlaceType != 0) {
        if (!this.filterUsed.includes("strPlaceType")) {
          this.filterUsed.push("strPlaceType");
        }
      } else {
        const data = this.filterUsed.filter(
          (item, pos) => item != "strPlaceType"
        );
        this.filterUsed = data;
      }
    },
    changeQueryString() {
      this.$router.replace({
        query: {
          city: this.strCity || undefined,
          check_in: this.search.datefrom || undefined,
          check_out: this.search.dateto || undefined,
          adult: this.search.adults || undefined,
          child: this.search.children || undefined,
          project_category: this.filter.strProjectCategory || undefined,
          min_price: this.filter.dcmMinPrice || undefined,
          max_price: this.filter.dcmMaxPrice || undefined,
          place_type: this.filter.strPlaceType || undefined,
          sort_by: this.filter.strSort || undefined,
          email: this.email_address || undefined,
          exp: this.email_confirmation_date || undefined,
        },
      });
    },
  },
};
</script>
